import React from 'react';
import styled from 'styled-components';

import { ApiWithdrawal } from 'api/types';
import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import Link from 'components/basic/Link/Link';
import ModalContent from 'components/basic/modal/components/ModalContent';
import ModalFooterButtons from 'components/basic/modal/components/ModalFooterButtons';
import SimpleModalOrMobilePage from 'components/basic/modal/SimpleModalOrMobilePage';
import { getBlockExplorerTransactionUrl } from 'config/configUtils';
import { Chains } from 'config/constants';
import { formatUsd } from 'lib/display/formatting';
import { redirectTo } from 'lib/redirect';

const Center = styled.div`
  text-align: center;
`;

const Heading = styled.h2`
  max-width: 600px;
  padding: 0;
`;

const IconWrap = styled.div`
  font-size: 90px;
  line-height: 0;
  padding-bottom: 18px;
`;

const Text = styled.p`
  color: var(--gray4c);
  line-height: normal;
`;

type Props = {
  // withdrawal: Pick<ApiWithdrawal, 'katanaTxStatus' | 'katanaTxId' | 'quantity' | ''>;
  withdrawal: ApiWithdrawal;
  onClose: () => void;
  activeChain: Chains;
};

function WithdrawalResultErrorModal({
  withdrawal,
  activeChain,
  onClose,
}: Props) {
  return (
    <SimpleModalOrMobilePage
      onClose={onClose}
      size="small"
      title="Withdraw USDC"
      padding="0"
    >
      <ModalContent>
        <Center>
          <IconWrap>
            <MaterialSymbol
              icon="cancel"
              color="var(--red3)"
              fontSize="inherit"
              rounded
            />
          </IconWrap>
          <Heading style={{ color: 'var(--red3)' }}>
            Your withdrawal of
            <br />
            {formatUsd(withdrawal.quantity)} USDC failed to mine.
          </Heading>
          {withdrawal.katanaTxId && (
            <Text>
              You can see details of {withdrawal.katanaTxStatus} transaction on{' '}
              <Link
                href={getBlockExplorerTransactionUrl(
                  withdrawal.katanaTxId,
                  activeChain
                )}
              >
                Block Explorer
              </Link>
              .
            </Text>
          )}
        </Center>
      </ModalContent>
      <ModalFooterButtons
        confirmButtonProps={{
          inline: true,
          onClick: () => {
            onClose();
            redirectTo('/wallet/history/deposits-withdrawals');
          },
          bordered: true,
          children: 'View Balance History',
        }}
      />
    </SimpleModalOrMobilePage>
  );
}

export default WithdrawalResultErrorModal;
